module.exports = __webpack_public_path__ + "img/link01_sp.c6fbc79f.png";